import React from 'react';
import { Link } from 'react-router-dom';
import { type GuideItem } from '@lib/content';
import { getGuidePath } from '@lib/guides';

interface GuidesSectionProps {
  guides?: GuideItem[];
}

const GuidesSection: React.FC<GuidesSectionProps> = ({ guides }) => {
  if (!guides || guides.length === 0) {
    return null;
  }

  return (
    <div className="info-the-game guides-section" style={{ marginTop: '2rem' }}>
      <h2>PokéRogue Guides</h2>
      <p>Need help with a specific mechanic or a difficult part of your run? Explore the PokéRogue guides below.</p>
      <div className="guides-list">
        {guides.map((guide) => (
          <article key={guide.slug} className="guide-card">
            <div className="guide-card-header">
              <h3 className="guide-card-title">{guide.title}</h3>
              <Link to={getGuidePath(guide.slug)} className="guide-card-link">
                Read Guide
              </Link>
            </div>
            <p className="guide-card-description">{guide.description}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default GuidesSection;
